import '../scss/theme.scss';

// For jquery: see 'bootstrap_italia.libraries.yml'
//import '../../node_modules/jquery/dist/jquery.js';
import '../../node_modules/popper.js/dist/umd/popper'
import '../../node_modules/owl.carousel/dist/owl.carousel'

import '../../node_modules/bootstrap/dist/js/bootstrap'
import '../../node_modules/bootstrap-select/js/bootstrap-select'
import '../../node_modules/bootstrap-select/js/i18n/defaults-it_IT'
import '../../node_modules/svgxuse/svgxuse'

import '../../node_modules/bootstrap-italia/src/js/plugins/polyfills/array.from'
import '../../node_modules/bootstrap-italia/src/js/plugins/circular-loader/CircularLoader-v1.3'
import '../../node_modules/bootstrap-italia/src/js/plugins/password-strength-meter/password-strength-meter'
import '../../node_modules/bootstrap-italia/src/js/plugins/datepicker/locales/it'
import '../../node_modules/bootstrap-italia/src/js/plugins/datepicker/datepicker'
import '../../node_modules/bootstrap-italia/src/js/plugins/i-sticky/i-sticky'
import '../../node_modules/bootstrap-italia/src/js/plugins/sticky-header'
import '../../node_modules/bootstrap-italia/src/js/plugins/sticky-wrapper'
import '../../node_modules/bootstrap-italia/src/js/plugins/ie'
import '../../node_modules/bootstrap-italia/src/js/plugins/fonts-loader'
import '../../node_modules/bootstrap-italia/src/js/plugins/autocomplete'
import '../../node_modules/bootstrap-italia/src/js/plugins/back-to-top'
import '../../node_modules/bootstrap-italia/src/js/plugins/componente-base'
import '../../node_modules/bootstrap-italia/src/js/plugins/cookiebar'
import '../../node_modules/bootstrap-italia/src/js/plugins/dropdown'
//import '../../node_modules/bootstrap-italia/src/js/plugins/forms'
import './custom/forms'
import '../../node_modules/bootstrap-italia/src/js/plugins/track-focus'
import '../../node_modules/bootstrap-italia/src/js/plugins/forward'
import '../../node_modules/bootstrap-italia/src/js/plugins/navbar'
import '../../node_modules/bootstrap-italia/src/js/plugins/navscroll'
import '../../node_modules/bootstrap-italia/src/js/plugins/history-back'
import '../../node_modules/bootstrap-italia/src/js/plugins/notifications'
import '../../node_modules/bootstrap-italia/src/js/plugins/upload'
import '../../node_modules/bootstrap-italia/src/js/plugins/progress-donut'
import '../../node_modules/bootstrap-italia/src/js/plugins/list'
import '../../node_modules/bootstrap-italia/src/js/plugins/imgresponsive'
import '../../node_modules/bootstrap-italia/src/js/plugins/timepicker'
import '../../node_modules/bootstrap-italia/src/js/plugins/input-number'
import '../../node_modules/bootstrap-italia/src/js/plugins/carousel'
import '../../node_modules/bootstrap-italia/src/js/plugins/transfer'
import '../../node_modules/bootstrap-italia/src/js/plugins/select'
import '../../node_modules/bootstrap-italia/src/js/plugins/rating'
import '../../node_modules/bootstrap-italia/src/js/plugins/dimmer'

// example js
//import './custom/example'

// Custom theme script
import './custom/component-library-initialization'
